<app-habitation-page-container>
  <div class="page-content">
    <div class="liste-proprietes">
      <div class="list-container mobile">
        <div *ngIf="loaded">
          <div class="empty-list" *ngIf="listeProprietes.length === 0">
            <img src="{{ 'assets/images/image-empty-list.svg' | cheminAbsoluStatique }}" alt="" class="empty-house" />
            <h1 appFocusOnInit class="titre-page" id="titre-page-1">{{ 'propriete.liste.empty-titre' | translate }}</h1>
            <p>{{ 'propriete.liste.empty-texte' | translate }}</p>
            <div class="btn-container">
              <button
                id="btn-ajouter-new"
                mat-button
                class="green"
                (click)="navigateTo('propriete/creation-propriete')"
              >
                {{ 'propriete.liste.empty-btn-ajouter' | translate }}
              </button>
            </div>
          </div>

          <h1
            appFocusOnInit
            class="titre-page"
            *ngIf="listeProprietes.length > 0"
            class="titre-desktop"
            id="titre-page-2"
          >
            {{ 'propriete.liste.titre' | translate }}
          </h1>
          <div class="cartes" *ngIf="listeProprietes.length > 0">
            <button
              class="carte add-card"
              id="add-property-card"
              [@slideRevealAnimation]
              (click)="navigateTo('propriete/creation-propriete')"
            >
              <div class="card-content">
                <img src="{{ 'assets/images/paiement-frais-icone.svg' | cheminAbsoluStatique }}" alt="" class="icon" />
                <div class="cta-text">
                  {{ 'propriete.creation.titre' | translate }}
                </div>
              </div>
            </button>
            <div class="carte" *ngFor="let propriete of listeProprietes">
              <app-carte-propriete-liste
                [propriete]="propriete"
                [capaciteStatus]="capaciteStatus"
                (goToDetail)="navigateTo('propriete/detail/' + propriete.id)"
                [@slideRevealAnimation]
              ></app-carte-propriete-liste>
            </div>
          </div>
        </div>

        <button mat-button class="button-back  no-border" id="btn-rtn-accueil" (click)="navigateTo('')">
          <img
            src="{{ 'assets/images/arrow/green-left.svg' | cheminAbsoluStatique }}"
            alt=""
            class="button-icone-left"
          />
          {{ 'btn.retour-accueil' | translate }}
        </button>
      </div>
    </div>
  </div>
</app-habitation-page-container>

<app-sub-footer [enableNextStep]="true" [nextStep]="'preauth'"></app-sub-footer>
